import React from "react";

const BodySketchUpper = () => (
  <g
    transform="translate(0,17700) scale(1,-1)"
    fill="#000000"
    stroke="none"
    className="body"
  >
    <path
      stroke="#000"
      strokeWidth="60"
      d="M6055 17695 c-283 -56 -345 -75 -345 -104 0 -21 -18 -31 -59 -31 -15
0 -38 -9 -51 -20 -13 -11 -27 -20 -33 -20 -18 0 -132 -89 -189 -147 -131 -135
-302 -374 -383 -533 -18 -34 -65 -207 -65 -236 0 -9 -7 -31 -16 -50 -9 -19
-14 -46 -11 -61 3 -16 7 -35 9 -43 1 -8 -1 -68 -6 -132 -5 -77 -4 -128 3 -150
6 -18 17 -100 26 -183 9 -82 22 -172 30 -200 24 -89 23 -98 -21 -148 -49 -55
-75 -135 -81 -247 -11 -174 98 -527 192 -623 19 -19 52 -43 74 -53 22 -11 43
-26 45 -34 3 -8 19 -89 36 -180 36 -187 80 -339 139 -484 40 -98 41 -101 41
-225 0 -141 -21 -348 -46 -447 -40 -158 -176 -260 -669 -504 -305 -151 -519
-248 -740 -337 -88 -35 -198 -85 -245 -110 -115 -63 -213 -112 -350 -176 -175
-82 -287 -178 -366 -313 -80 -136 -206 -638 -253 -1004 -27 -208 -41 -569 -41
-1061 0 -439 -4 -505 -65 -1007 -19 -158 -50 -427 -70 -599 -40 -353 -62 -485
-103 -628 -28 -96 -40 -129 -130 -345 -129 -313 -249 -713 -312 -1050 -17 -91
-54 -280 -81 -420 -28 -140 -88 -487 -135 -772 -119 -734 -139 -830 -219
-1078 -24 -74 -57 -200 -74 -280 -17 -80 -60 -253 -96 -385 -36 -132 -72 -277
-80 -322 -32 -184 -146 -323 -452 -556 -33 -26 -76 -63 -94 -82 -18 -19 -38
-35 -44 -35 -15 0 -62 -51 -130 -144 -32 -43 -113 -135 -179 -205 -67 -69
-136 -143 -154 -164 -22 -26 -62 -52 -126 -82 -94 -44 -106 -55 -106 -104 0
-70 59 -101 193 -101 180 0 263 36 437 190 l125 111 3 -33 c5 -48 -15 -274
-46 -518 -25 -202 -27 -237 -26 -580 l2 -364 28 -24 c58 -48 89 -62 135 -62
62 0 109 32 125 85 7 22 13 38 14 35 0 -3 5 -62 10 -132 6 -80 15 -139 25
-158 l16 -31 117 3 117 3 13 40 c9 27 15 132 19 327 3 158 9 285 13 283 15 -9
19 -189 8 -342 -13 -184 -10 -206 41 -240 64 -43 166 -21 203 43 28 48 37 145
48 534 13 473 17 519 41 560 11 18 24 29 29 24 13 -14 89 -362 144 -659 23
-119 45 -168 84 -184 73 -30 166 25 178 105 11 77 -14 329 -56 559 -55 298
-54 330 12 670 l53 270 -3 242 c-3 308 14 438 82 623 25 69 95 267 155 442
189 542 277 765 436 1108 160 343 274 628 485 1206 48 133 122 322 163 420 84
198 200 532 217 622 6 31 14 172 19 312 l9 255 42 150 c68 248 159 620 194
795 l33 165 16 -107 c52 -334 70 -686 57 -1108 -10 -313 -24 -433 -81 -704
-121 -571 -109 -491 -119 -816 -19 -597 -31 -701 -110 -955 -61 -196 -74 -252
-99 -430 -29 -199 -39 -354 -51 -735 -6 -184 -14 -434 -18 -555 -8 -231 -3
-370 23 -650 55 -600 139 -1257 240 -1885 24 -151 47 -301 50 -332 6 -53 8
-58 31 -58 25 0 25 1 19 62 -4 35 -29 200 -55 368 -105 656 -189 1323 -245
1963 -20 222 -21 284 -6 812 21 805 53 1096 151 1392 82 250 97 360 110 823 6
195 15 393 21 440 5 47 39 222 75 390 90 422 104 530 112 855 13 511 -7 867
-68 1205 -22 122 -38 153 -68 134 -18 -11 -27 -46 -62 -234 -24 -131 -138
-601 -200 -825 l-42 -150 -9 -260 c-5 -143 -14 -285 -20 -315 -18 -89 -125
-391 -206 -585 -42 -99 -115 -288 -164 -420 -194 -533 -318 -843 -454 -1140
-209 -456 -251 -560 -493 -1245 -112 -316 -182 -531 -195 -595 -17 -84 -20
-145 -22 -385 l-1 -285 -53 -275 c-51 -264 -53 -280 -48 -400 3 -83 17 -189
41 -315 43 -222 67 -489 48 -530 -13 -28 -72 -61 -96 -52 -24 10 -44 58 -62
153 -58 311 -127 624 -148 671 -30 64 -87 49 -126 -32 -21 -43 -23 -66 -31
-358 -12 -402 -26 -652 -39 -700 -15 -50 -62 -75 -116 -61 -58 14 -60 23 -46
207 11 142 10 188 -4 338 -16 166 -15 206 2 435 5 68 4 83 -11 98 -42 41 -57
-3 -79 -229 -9 -93 -21 -323 -26 -510 -5 -187 -12 -355 -16 -373 -13 -65 -113
-82 -163 -28 -19 21 -24 41 -33 157 -6 74 -11 293 -12 486 -1 256 -4 354 -13
357 -49 19 -72 -110 -77 -439 -4 -263 -11 -316 -43 -341 -36 -27 -105 -11
-146 34 -16 17 -18 51 -24 318 -5 269 -3 318 17 484 39 333 50 443 56 596 6
139 6 151 -11 158 -22 8 -39 -3 -149 -100 -191 -169 -211 -183 -313 -209 -70
-18 -219 -19 -253 -2 -14 7 -26 23 -28 35 -3 20 8 28 84 63 78 36 97 51 179
137 197 209 249 268 317 358 39 52 76 94 82 94 7 0 28 16 47 36 18 20 89 78
156 131 67 52 167 138 221 191 85 82 106 110 141 182 27 56 46 114 56 170 8
47 44 192 80 324 35 131 78 303 95 382 17 79 53 213 79 297 78 243 93 318 221
1102 44 270 100 591 125 715 24 124 60 311 80 415 35 182 81 380 125 529 32
111 169 492 213 591 120 275 153 414 206 885 17 146 51 436 75 645 63 534 66
570 66 1040 0 455 12 788 35 985 42 368 174 891 260 1035 80 133 206 232 408
320 69 30 169 80 223 111 107 60 156 82 365 167 297 120 908 417 1088 528 112
69 232 184 260 249 36 83 62 266 68 475 l5 190 -50 125 c-64 160 -94 268 -138
488 -19 97 -40 183 -47 189 -7 7 -33 23 -57 35 -83 43 -147 162 -202 378 -58
232 -46 370 41 463 41 44 46 54 44 91 -1 23 -8 67 -17 97 -8 30 -22 119 -31
199 -8 80 -20 168 -26 195 -7 34 -8 84 -2 155 6 60 6 119 1 137 -6 20 -5 40 1
51 9 17 26 85 52 211 19 91 190 351 363 553 68 79 167 161 223 184 17 8 34 18
38 24 3 5 16 10 29 10 42 0 86 21 92 44 5 23 41 35 194 66 25 5 79 16 120 25
91 20 104 20 159 0 50 -17 107 -20 116 -5 4 7 11 7 18 2 24 -18 76 -21 138 -6
79 19 148 20 262 7 77 -9 93 -14 125 -42 20 -18 71 -48 112 -68 41 -20 100
-53 130 -73 30 -21 78 -52 107 -69 118 -73 362 -376 434 -539 56 -129 71 -219
72 -437 0 -288 -31 -597 -73 -727 l-22 -66 35 -51 c47 -67 78 -152 84 -226 9
-98 -66 -386 -134 -516 -51 -98 -78 -120 -155 -126 l-64 -5 -23 -117 c-12 -64
-39 -188 -59 -276 -35 -154 -36 -167 -34 -334 2 -195 14 -335 42 -461 63 -292
131 -346 935 -750 336 -169 472 -232 735 -340 217 -89 258 -110 410 -210 158
-104 281 -202 357 -284 131 -139 216 -391 299 -880 29 -174 42 -505 43 -1121
1 -580 19 -880 87 -1470 86 -755 113 -882 274 -1270 69 -168 226 -628 264
-778 14 -54 42 -196 61 -315 73 -452 185 -1178 225 -1457 62 -438 72 -481 214
-920 124 -383 172 -533 221 -690 84 -270 101 -292 437 -597 131 -118 213 -201
244 -246 73 -103 109 -150 184 -237 38 -44 98 -123 132 -175 53 -79 76 -104
142 -151 94 -68 104 -81 81 -116 -16 -25 -20 -25 -104 -21 -144 7 -223 52
-433 249 -64 60 -119 109 -122 109 -3 0 -6 -39 -6 -87 0 -97 20 -244 77 -553
l37 -205 0 -310 c1 -344 1 -347 -65 -381 -25 -13 -36 -13 -59 -4 -66 28 -73
53 -100 372 -23 280 -29 315 -70 445 -17 51 -30 105 -30 119 0 62 -51 89 -71
37 -11 -29 -8 -68 16 -188 21 -109 26 -268 15 -405 -6 -69 -15 -223 -19 -343
-8 -209 -9 -219 -32 -243 -35 -38 -88 -50 -128 -30 -17 9 -36 28 -41 42 -6 14
-10 141 -10 282 0 280 -12 508 -35 688 -16 123 -27 154 -50 154 -32 0 -38 -39
-31 -199 6 -121 4 -172 -8 -226 -22 -105 -35 -239 -42 -445 -7 -174 -9 -185
-30 -207 -26 -26 -60 -29 -108 -9 -28 12 -35 21 -41 54 -3 22 -5 280 -3 573 3
574 3 579 -47 579 -13 0 -27 -5 -30 -10 -4 -6 -10 -66 -15 -133 -5 -67 -16
-152 -25 -189 -8 -37 -20 -124 -25 -195 -21 -265 -35 -313 -93 -313 -93 0
-113 113 -82 455 25 281 17 529 -20 610 -8 16 -19 66 -25 111 -6 45 -15 96
-20 115 -31 103 -42 229 -49 524 -6 266 -9 315 -24 343 -10 18 -31 71 -48 119
-17 48 -103 253 -191 457 -88 204 -204 481 -258 616 -54 135 -165 407 -248
605 -165 398 -206 503 -358 933 -112 318 -153 425 -222 577 -54 122 -126 308
-182 475 l-42 124 -8 231 c-13 316 -14 324 -70 534 -65 245 -133 542 -165 716
-30 170 -75 500 -75 556 0 50 -15 79 -41 79 -32 0 -25 30 -149 -700 -62 -368
-74 -493 -74 -780 0 -286 6 -348 79 -720 94 -483 110 -607 130 -1045 8 -176
22 -385 32 -464 15 -131 19 -147 44 -176 30 -34 48 -93 79 -265 11 -63 30
-149 41 -190 11 -41 25 -103 29 -137 5 -35 25 -134 44 -220 42 -191 51 -250
72 -463 8 -91 27 -244 40 -340 44 -312 64 -512 64 -635 0 -191 -56 -844 -125
-1460 -30 -266 -69 -691 -92 -1007 l-6 -88 25 0 25 0 12 158 c30 390 54 649
86 932 69 614 125 1273 125 1469 0 119 -21 332 -64 640 -14 97 -32 248 -41
336 -22 222 -31 287 -71 467 -19 87 -39 186 -43 220 -5 35 -19 97 -30 139 -11
42 -32 136 -46 210 -31 171 -51 236 -80 265 -32 32 -51 192 -70 612 -21 455
-35 563 -135 1077 -70 360 -75 406 -75 690 1 330 3 352 144 1170 l27 160 8
-75 c30 -304 109 -700 227 -1145 54 -202 67 -307 69 -550 0 -60 5 -142 10
-181 10 -79 113 -380 192 -564 102 -236 148 -352 243 -620 156 -441 216 -597
364 -953 78 -185 185 -447 240 -584 54 -136 143 -349 196 -473 174 -404 237
-554 267 -635 16 -44 38 -104 49 -132 17 -46 19 -81 19 -283 0 -249 10 -371
41 -520 11 -52 25 -129 31 -170 5 -41 16 -87 23 -101 38 -70 45 -306 19 -602
-33 -371 0 -497 130 -497 93 0 113 35 132 232 13 134 22 201 54 398 4 25 5
-164 3 -420 -6 -504 -4 -524 48 -562 37 -28 125 -34 169 -11 45 23 59 63 59
169 1 134 21 394 37 469 8 39 14 81 14 94 0 13 3 21 7 18 3 -4 9 -177 12 -384
7 -422 5 -408 79 -444 50 -25 108 -20 159 11 57 34 62 58 73 307 6 126 15 284
20 353 6 69 8 166 6 215 -9 171 12 20 34 -240 11 -137 28 -274 36 -304 17 -61
46 -92 104 -111 36 -12 46 -11 87 6 96 40 107 93 100 479 -4 255 -7 281 -41
475 -44 244 -76 454 -76 493 0 27 4 25 91 -57 164 -154 266 -207 415 -214 113
-5 148 9 164 67 16 60 -1 93 -73 140 -78 50 -123 97 -180 186 -24 39 -81 113
-126 165 -45 52 -108 133 -140 180 -62 89 -137 165 -389 394 -227 206 -244
233 -333 524 -28 92 -97 309 -154 482 -193 587 -201 621 -269 1101 -25 173
-79 530 -120 794 -151 958 -141 910 -258 1265 -84 257 -137 400 -212 578 -118
282 -151 452 -241 1242 -58 518 -74 798 -75 1315 -1 176 -5 482 -10 680 -7
333 -10 373 -38 536 -79 455 -163 711 -286 861 -56 68 -206 191 -364 296 -166
111 -222 140 -442 230 -255 104 -399 171 -737 341 -563 284 -704 367 -803 479
-84 94 -123 255 -141 584 -10 182 -9 215 5 285 9 43 36 170 60 283 l42 205 58
12 c123 24 191 140 271 463 41 161 43 231 12 332 -14 46 -40 105 -58 133 l-31
49 15 51 c47 151 85 636 68 860 -13 166 -25 220 -72 328 -45 101 -85 164 -201
309 -110 140 -189 215 -284 272 -43 27 -91 59 -106 71 -15 13 -53 33 -85 45
-31 11 -72 35 -92 52 -53 47 -108 68 -178 68 -35 0 -65 5 -69 11 -9 15 -132 5
-215 -16 -52 -14 -62 -14 -95 0 -44 18 -71 19 -77 3 -3 -10 -14 -10 -53 1 -68
20 -127 22 -209 6z"
    />
    <path
      stroke="#000"
      strokeWidth="60"
      d="M6531 1190 c-115 -67 -194 -82 -296 -55 -42 11 -47 -5 -87 -281 -21
-148 -61 -379 -87 -514 -27 -135 -52 -266 -56 -293 -7 -45 -6 -47 18 -47 22 0
26 6 32 43 4 23 29 154 56 292 38 188 119 696 119 740 0 2 26 2 58 -1 84 -9
165 11 255 63 43 25 80 43 83 41 2 -3 17 -90 34 -194 40 -256 49 -301 132
-666 69 -302 74 -318 95 -318 15 0 23 6 23 18 0 9 -27 134 -61 277 -80 346
-101 452 -139 695 -32 205 -46 250 -78 250 -9 0 -55 -22 -101 -50z"
    />
  </g>
);

export default BodySketchUpper;
